export default function BlockMissing({ record }) {
  return (
    <>
      <p>Don't know how to render a block!</p>
      <pre>{JSON.stringify(record, null, 2)}</pre>
      <p>ModelAPI Key: {JSON.stringify(record._modelApiKey, null, 2)}</p>
    </>
  );
}
